<template>
  <div class="org" role="img" aria-label="조직도: 대표이사 아래 품질보증부, 영업팀, 개발사업부, 기술연구소, 운영팀">
    <div class="head-wrap">
      <div class="head">{{ org.head }}</div>
    </div>
    <div class="staff-wrap">
      <div class="staff">
        <div class="node lead">{{ org.staff.title }}</div>
        <div v-for="it in org.staff.items" :key="it" class="node sub">{{ it }}</div>
      </div>
    </div>
    <div class="teams">
      <div v-for="t in org.teams" :key="t.title" class="team">
        <div class="node lead">{{ t.title }}</div>
        <div v-for="it in t.items" :key="it" class="node sub">{{ it }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { organization } from '@/data/company';

export default {
  name: 'OrgChart',
  data() { return { org: organization }; },
};
</script>

<style scoped>
.org { --line-c: #cbd5e1; display: flex; flex-direction: column; align-items: center; }
.head-wrap { position: relative; padding-bottom: 36px; }
.head-wrap::after { content: ""; position: absolute; left: 50%; bottom: 0; width: 2px; height: 36px; background: var(--line-c); transform: translateX(-50%); }
.head { width: 136px; height: 136px; border-radius: 999px; background: var(--navy); color: #ffffff; display: flex; align-items: center; justify-content: center; font-size: 20px; font-weight: 700; box-shadow: 0 0 0 8px #e2e8f0; }
.staff-wrap { position: relative; width: 100%; display: flex; justify-content: flex-start; padding-bottom: 36px; }
.staff-wrap::before { content: ""; position: absolute; left: 50%; top: 0; bottom: 0; width: 2px; background: var(--line-c); transform: translateX(-50%); }
.staff { position: relative; margin-left: 50%; padding-left: 120px; display: flex; flex-direction: column; gap: 8px; }
.staff::before { content: ""; position: absolute; left: 0; top: 24px; width: 120px; height: 2px; background: var(--line-c); }
.teams { position: relative; display: grid; grid-template-columns: repeat(4, 220px); gap: 24px; padding-top: 36px; }
.teams::before { content: ""; position: absolute; top: 0; left: 110px; right: 110px; height: 2px; background: var(--line-c); }
.team { position: relative; display: flex; flex-direction: column; gap: 8px; }
.team::before { content: ""; position: absolute; left: 50%; top: -36px; width: 2px; height: 36px; background: var(--line-c); transform: translateX(-50%); }
.node { border-radius: 999px; padding: 12px 16px; text-align: center; font-size: 15px; font-weight: 600; }
.node.lead { background: var(--navy); color: #ffffff; }
.node.sub { background: #ffffff; border: 1px solid var(--line); color: var(--ink-2); }
@media (max-width: 1000px) {
  .staff { margin-left: 0; padding-left: 0; }
  .staff::before { content: none; }
  .staff-wrap::before { content: none; }
  .staff-wrap { padding-bottom: 24px; }
  .teams { grid-template-columns: repeat(2, minmax(0, 1fr)); width: 100%; padding-top: 0; }
  .teams::before, .team::before { content: none; }
  .head-wrap::after { content: none; }
  .head-wrap { padding-bottom: 24px; }
}
</style>
